import { FORM_FIELD_ERROR_CODE_MAPPING } from '~/src/utils/constants';

const hasKey = (obj: Record<string, any>, key: string) => {
  return typeof obj[key] !== 'undefined';
};
export { hasKey };

const getFieldErrorKey = (field_key: string, error: string) => {
  return (
    field_key +
    '_' +
    FORM_FIELD_ERROR_CODE_MAPPING[
      error as keyof typeof FORM_FIELD_ERROR_CODE_MAPPING
    ]
  );
};
export { getFieldErrorKey };

const delayMilliseconds = (delay: number) => {
  return new Promise((resolve) => {
    setTimeout(resolve, delay);
  });
};
export { delayMilliseconds };
